import React from 'react';
import AuthContextProvider from './Context/Auth/index.js';
import { withAuthentication } from './hoc/withAuthentication.js';
import { App } from './UI/App/index.js';

function AppProvided() {
  return (
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  );
}

export default withAuthentication(AppProvided);
